import auth0 from 'auth0-js';
import { fetchGraphQL } from "../fetchGraphQL/fetchGraphQL";
import { getDynamicConfigValue } from '../dynamicConfig';
import { identify } from "../util/tracking";
import { setKeymakerApiKey } from "../graphql/keymakerApiKey";

class Auth {
  constructor() {
    this.auth0 = new auth0.WebAuth({
      domain: process.env.REACT_APP_AUTH_DOMAIN,
      clientID: process.env.REACT_APP_AUTH_CLIENT_ID,
      redirectUri: process.env.REACT_APP_AUTH_CALLBACK,
      responseType: 'token id_token',
      scope: 'openid email profile',
      sso: false
    });
    this.login = this.login.bind(this);
    this.silentAuth = this.silentAuth.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    //this.setSession=this.setSession.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.logout = this.logout.bind(this);

    this.idTokenPayload = {};    
    this.userAcessInfo = {};
  }

  login() {
    this.auth0.authorize({
      prompt: 'select_account',
      theme: { primaryColor: '#0085be' }
    });
  }

  isAuth0 = () => getDynamicConfigValue('REACT_APP_AUTH_METHOD') === "auth0";  

  getIdToken() {
    return localStorage.getItem("id_token");
  }

  getUser() {}
  async handleSignUp() {
    const uri = process.env.REACT_APP_HIVE_URI;
    const query = `
      mutation MergeUserAndLogSignIn($id: ID!) {
        mergeUserAndLogSignIn(id: $id){
          email
          name
          picture
        }
      }
    `;
    const variables = {
      id: process.env.REACT_APP_SOLUTION
    };

    const token = this.getIdToken();
    
    await fetchGraphQL({ uri, query, variables, token })
      .then(result => {})
      .catch(error => {
        console.log(error);
      });
  }

  handleAuthentication() {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash((err, authResult) => {
        if (err) return reject(err);
        if (!authResult || !authResult.idToken) {
          return reject(err);
        }
        this.setSession(authResult);
        //this.handleSignUp();
        resolve();
      });
    });
  }

  setSession(authResult) {
    // Set the time that the access token will expire at
    this.idToken = authResult.idToken;
    localStorage.setItem('User', JSON.stringify(authResult.idTokenPayload));
    this.expiresAt = authResult.expiresIn * 1000 + new Date().getTime();
    this.idTokenPayload = authResult.idTokenPayload;

    // Set the time that the access token will expire at, in this case 1 hour
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', this.expiresAt);
  }

  silentAuth = async () => {
    //console.log('silentAuth');
    //alert('silentAuth')
    // if (this.isAuth0() && !this.getIdToken()) {
    //   //alert('throwing error login_required');
    //   throw new Error('login_required');      
    // }

    var promise = new Promise((resolve, reject) => {
      this.auth0.checkSession({}, async (err,authResult)=>{
        if (err) return reject(err);
        if (!authResult || !authResult.idToken) {
          return reject(err);
        }
        //console.log('silentAuth setSession');
        this.setSession(authResult); 

        const result = await this.verifyDemoAccess({caller: 'silentAuth'});
        if (!result.hasAccess) {
          this.removeLocalStorageItems();
          window.location.replace(getDynamicConfigValue('REACT_APP_HIVE_UI'));
        }
        this.userAcessInfo = result;
        setKeymakerApiKey(this.userAcessInfo.keymakerApiKey);
        
        // send identity info to segement analytics
        identify("FRAUD-AML_AUTH_IDENTITY", this.idTokenPayload.email, { 
          email: this.idTokenPayload.email,
          sub: this.idTokenPayload.sub,
          organization: this.userAcessInfo.userPrimaryOrganization
        });

        resolve(result.hasAccess);
      });
    });
    return await promise;
  }

  logout() {
    // Clear access token and ID token from local storage
    //  this.auth0.logout({
    //    returnTo: process.env.REACT_APP_AUTH_LOGOUT_URL,
    //     clientID: process.env.REACT_APP_AUTH_CLIENT_ID
    // });
    this.removeLocalStorageItems();
    localStorage.clear();

    const authDomain = getDynamicConfigValue("REACT_APP_AUTH_DOMAIN") || "REACT_APP_AUTH_DOMAIN not specified";
    const logoutUrl = getDynamicConfigValue("REACT_APP_AUTH_LOGOUT_URL") || "REACT_APP_AUTH_LOGOUT_URL not specified"
    const clientId = getDynamicConfigValue("REACT_APP_AUTH_CLIENT_ID") || "REACT_APP_AUTH_CLIENT_ID not specified"
    
    window.location.replace(
      `https://${authDomain}/v2/logout/?returnTo=${logoutUrl}&client_id=${clientId}`
    );
  }

  isAuthenticated() {
    // Check whether the current time is past
    return new Date().getTime() < this.expiresAt;
  }

  removeLocalStorageItems () {
    localStorage.removeItem('user');
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
  }

  verifyDemoAccess = async ({caller}) => {
    if (this.isAuth0() && !this.getIdToken()) {
      return false;      
    }

    const uri = getDynamicConfigValue('REACT_APP_HIVE_URI');
    /*
    const query = `
      mutation MergeUserAndLogSignIn($id: ID!) {
        mergeUserAndLogSignIn(id: $id){
          email
        }
      }
    `;
    */
   const query = `
      mutation verifyUserHasAccessToSolution ($baseUrl: String!) {
        result: verifyUserHasAccessToSolution(baseUrl: $baseUrl) {
          hasAccess
          keymakerApiKey
          userPrimaryOrganization
          solutionId
          solutionName
          solutionType
          matchingDeploymentId
          matchingDeploymentUrl
          matchingDeploymentName
        }
      }
   `
    const variables={
      baseUrl: getDynamicConfigValue('REACT_APP_SOLUTION_BASE_URL_IN_HIVE')};

    const token = this.getIdToken();

    var promise = new Promise((resolve, reject) => {
      fetchGraphQL({ uri, query,variables, token })
      .then((result) => {
        const { data, errors } = result;
        if (errors) {
          console.log(`${caller} verifyDemoAccess access check error (1)`);
          console.log(errors);
          alert(`${caller} verifyDemoAccess access check error (1): ${JSON.stringify(errors)}, returning to Hive.`);
          resolve({hasAccess: false});
        } else {
          if (data.result && data.result.hasAccess === false) {
            alert('You have not been granted access to this demo, returning to Hive.');
            resolve(data.result);
          } else {
            resolve(data.result);
          }
        }        
      })
      .catch(error => {
        console.log(`${caller} verifyDemoAccess access check error (2)`);
        console.log(error);
        alert(`${caller} verifyDemoAccess access check error (2): ${JSON.stringify(error)}, returning to Hive.`);
        resolve({hasAccess: false});
      });
    })
    return await promise;
  }
}

const auth = new Auth();
export default auth;
